import * as React from 'react';
import { IUserMilestones } from '../../../../../extViewmodels';
import { useEventLogging } from '../../../../../models/Logging';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { useUpdateUserMilestone } from '../../../../../queries';

export const useHasUsedWebApp = ({ eventLoggingCategory }: { eventLoggingCategory: string }) => {
	const userSession = useUserSession();
	const { logApiError } = useEventLogging(eventLoggingCategory);
	const updateUserMilestoneMutation = useUpdateUserMilestone({
		onSuccess: (userMilestones: IUserMilestones) => {
			userSession.user.userMilestones = userMilestones;
		},
		onError: error => {
			logApiError('SetUserMilestone-Error', error);
		},
		userSession,
	});
	React.useEffect(() => {
		if (!userSession.user.userMilestones || !userSession.user.userMilestones.hasUsedWebApp) {
			updateUserMilestoneMutation.mutate({ name: 'hasUsedWebApp', userId: userSession.user.id, value: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
